export const IconsCommon = {
  viewRotateClass: (toggleRotate: boolean = false) => (toggleRotate ? 'rotate' : 'urotate')
};
